import React, { useState, useContext, useEffect } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import { BankNameContext } from "../../context/BankNameContext";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import AuthorizationModal from "../authorizationModal/authorizationModal";
import { toast } from "react-toastify";
import confetti from "canvas-confetti";
import AddVectorIcon from "../../../src/assets/Icons/Add Vector.png";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import { addMonths, format, parseISO } from "date-fns";
import ApplyDateTimePicker from "../DateTimeField";

const AddCourierBagModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [formData, setFormData] = useState({
    bagNo: "",
    startDateTime: "",
  });

  const [errors, setErrors] = useState({
    bagNo: "",
    startDateTime: "",
  });
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { loading, error } = useContext(BankNameContext);

  useEffect(() => {
    if (action === "add") {
      setFormData({
        bagNo: "",
        startDateTime: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      action === "check"
    ) {
      setFormData({
        bagNo: editData?.bagNo || "",
        startDateTime: editData?.startDateTime || "",
      });
    }

    setErrors({
      bagNo: "",
      startDateTime: "",
    });
  }, [show]);

  if (loading) {
    return <p>Loading data...</p>;
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;
    if (id === "bagNo") updatedValue = value.toUpperCase();

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));

    // Clear error for the field while user edits
    setErrors((prev) => {
      if (!prev || !prev[id]) return prev;
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  const validate = () => {
    const newErrors = {};
    const { bagNo, startDateTime } = formData;

    // Bag No validations
    if (!bagNo.trim()) {
      newErrors.bagNo = "Bag No is required.";
    } else if (bagNo.trim().length < 3) {
      newErrors.bagNo = "Bag No must be at least 3 characters.";
    } else if (!/^[a-zA-Z0-9-]+$/.test(bagNo.trim())) {
      newErrors.bagNo =
        "Bag No can only contain letters, numbers, and hyphen (-).";
    }

    // Start Date & Time validations
    if (!startDateTime) {
        newErrors.startDateTime = "Start Date & Time is required.";
    } else {
      const selectedTime = new Date(startDateTime);
      if (selectedTime < new Date()) {
        newErrors.startDateTime = "Start Date & Time cannot be in the past.";
      }
    }


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const trimmedValue = value?.toString().trim();

    let fieldError = "";

    switch (id) {
      case "bagNo":
        if (!trimmedValue) {
          fieldError = "Bag No is required";
        } else if (trimmedValue.length < 3) {
          fieldError = "Bag No must be at least 3 characters";
        } else if (!/^[a-zA-Z0-9-]+$/.test(trimmedValue)) {
          fieldError =
            "Bag No can only contain letters, numbers, and hyphen (-)";
        }
        break;

      case "startDateTime":
        if (!trimmedValue) {
          fieldError = "Start Date & Time is required";
        } 
        // else {
        //   const selectedTime = new Date(trimmedValue);
        //   const now = new Date();
        //   if (isNaN(selectedTime.getTime())) {
        //     fieldError = "Invalid date/time";
        //   } else if (selectedTime < now) {
        //     fieldError = "Start Date & Time cannot be in the past";
        //   }
        // }
        break;

      default:
        break;
    }

    setErrors((prev) => {
      const next = { ...prev };
      if (fieldError) {
        next[id] = fieldError;
      } else {
        // remove previous error for this field when it's valid
        delete next[id];
      }
      return next;
    });
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";
  const isCheckMode = action === "check";

  const isReadOnly = isViewMode || isDeleteMode || isAuthMode || isCheckMode;

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddCourierModal = async () => {
    const isValid = validate();

    if (isValid) {
      let apiUrl = "";
      if (action === "add") {
        apiUrl = apiList.CREATE_BAG;
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_COURIER_MASTER;
      }

      try {
        const formattedStartDate = formData.startDateTime
          ? format(parseISO(formData.startDateTime), "dd-MM-yyyy HH:mm:ss")
          : "";

        const payload = {
          username: loggedInUserName,
          bagNo: formData.bagNo,
          startDateTime: formattedStartDate,
        };

        const response = await axiosPostApi(apiUrl, payload);
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          CustomAlert({
            title: response?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
            allowOutsideClick: false,
          });
          callApi(1);
          handleClose();
        } else if (response?.status === 200 && !response?.data?.status) {
          CustomAlert({
            title: "Failed to Request",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } catch (error) {
        console.error("Error processing request:", error);
        CustomAlert({
          title: "Error",
          text: "An error occurred. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    }
  };

  const authCourierMasterRequest = async (action, remarks) => {
    let status;
    let actionText;

    // Map the action to the correct status code
    switch (action?.approvalStatus) {
      case "approve":
        status = "2";
        actionText = "authorized";
        break;
      case "check":
        status = "1";
        actionText = "blocked";
        break;
      case "delete":
        status = "3";
        actionText = "blocked";
        break;
      case "reject":
        status = "5";
        actionText = "rejected";
        break;
      default:
        status = "5";
        actionText = "rejected";
    }

    const requestBody = {
      username: loggedInUserName,
      id: columnData?.id,
      status:
        isAuthMode && action?.approvalStatus !== "reject"
          ? "1"
          : isDeleteMode
          ? "3"
          : status,
      ...(action !== "delete" && { adminRemark: action?.remark }),
    };

    try {
      const response = await axiosPostApi(
        apiList.AUTH_COURIER_MASTER_DATA,
        requestBody
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed && isAuthMode) {
          } else {
            callApi(1);
          }
        });

        if (action === "approve") {
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
        }
        handleClose();
      } else {
        CustomAlert({
          title: `Failed to ${actionText} LMBP(Courier)`,
          text:
            response.data?.message || "Invalid credentials. Please try again!",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error(`Error ${actionText} customer`, error);
      toast.error(`Failed to ${actionText} customer.`);
    }
  };

  const handleAuth = () => {
    setShowAuthModal(true);
  };

  const handleCloseModal = () => {
    setShowAuthModal(false);
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[800px] min-h-fit h-[241px] rounded-3xl p-6 bg-white border border-gray-200">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title font-medium text-lg">
                    Add Courier Bag
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div className="modal-body space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    {/* Bag No */}
                    <div className="form-group">
                      <label htmlFor="bagNo">
                        Bag No<span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <i className="fa fa-briefcase absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                        <input
                          type="text"
                          className="form-control w-full !border-[#DDDDDD] !rounded-[5px] pl-10"
                          placeholder="Enter Bag No"
                          id="bagNo"
                          value={formData.bagNo}
                          disabled={isReadOnly}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      {!isReadOnly && errors.bagNo && (
                        <span className="error text-red-500 text-sm">
                          {errors.bagNo}
                        </span>
                      )}
                    </div>

                    {/* Start Date & Time */}
                    {/* <div className="form-group">
                      <label htmlFor="startDateTime">
                        Start Date & Time<span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <i className="fa fa-clock absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                        <input
                          type="datetime-local"
                          className="form-control w-full !border-[#DDDDDD] !rounded-[5px] pl-10"
                          id="startDateTime"
                          value={formData.startDateTime}
                          min={new Date().toISOString().slice(0, 16)}
                          disabled={isReadOnly}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      {!isReadOnly && errors.startDateTime && (
                        <span className="error text-red-500 text-sm">
                          {errors.startDateTime}
                        </span>
                      )}
                    </div> */}

                     <div className="form-group">
                        <label htmlFor="startDateTime">
                          Start Date & Time<span className="text-red-500">*</span>
                        </label>

                        <div className="relative">
                         {/* <ApplyDateTimePicker
                           id="startDateTime"
                           value={formData.startDateTime}
                           disabled={isReadOnly}
                           minDate={new Date()}
                           onChange={(date) =>
                             setFormData((prev) => ({
                               ...prev,
                               startDateTime: date.toISOString(),
                             }))
                           }
                           onBlur={handleBlur}
                         /> */}
                         <ApplyDateTimePicker
                           id="startDateTime"
                           value={formData.startDateTime}
                           disabled={isReadOnly}
                           minDate={new Date()}
                           maxDate={addMonths(new Date(), 1)}
                           onChange={(date) => {
                             setFormData((prev) => ({
                               ...prev,
                               startDateTime: date.toISOString(),
                             }));
                         
                             // ✅ clear error immediately
                             setErrors((prev) => {
                               const next = { ...prev };
                               delete next.startDateTime;
                               return next;
                             });
                           }}
                         />
                       </div>                 
                       {!isReadOnly && errors.startDateTime && (
                         <span className="error text-red-500 text-sm">
                           {errors.startDateTime}
                         </span>
                       )}
                     </div>
                  </div>
                </div>

                <div className="flex justify-center gap-4 pt-4 border-t-0">
                  <button
                    type="button"
                    className="btn btn-back w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  {!isReadOnly && (action === "add" || action === "modify") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleAddCourierModal}
                    >
                      {action === "modify" ? "Update" : "Submit"}
                    </button>
                  )}
                  {(action === "auth" || action === "check") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleAuth}
                      disabled={columnData?.authStatus === "APPROVED"}
                    >
                      Next
                    </button>
                  )}
                  {action === "delete" && (
                    <button
                      type="button"
                      className="btn btn-danger w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={() => authCourierMasterRequest(action)}
                    >
                      Reject
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <AuthorizationModal
        show={showAuthModal}
        handleClose={handleCloseModal}
        callApi={authCourierMasterRequest}
      />
    </>
  );
};

export default AddCourierBagModal;
